<template>
  <div class="ml-5 mr-5">
    <div class="text-right">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="dots"
        color="#007bff"
        :height="45"
        :width="75"
        :is-full-page="fullPage"
      ></loading>
    </div>
    <!-- v-data-table  -->

    <v-row style="margin-top: 0px">
      <v-col cols="12">
        <v-btn
          small
          color="primary"
          style="float: right"
          @click="deleteRetrievalRecord"
        >
          Delete
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="tableWrapper">
          <div id="select-all-checkbox">
            <v-checkbox
              ref="n"
              v-model="allSelected"
              color="secondry"
              @click="selectAll"
            ></v-checkbox>
          </div>

          <v-data-table
            :headers="headers"
            item-key="retrieval_id"
            :items="retrieval_data"
            :items-per-page="perpage"
            class="elevation-1"
            hide-default-footer
          >
            <template v-slot:item.selectCheckbox="{ item }">
              <v-checkbox
                v-model="selectedRetrievalRecords"
                :value="item.retrieval_id"
                :key="item.retrieval_id"
                @click="addToSubmit(item.retrieval_id)"
              ></v-checkbox>
            </template>
            <template v-slot:item.detail="{ item }">
              <div>
                <span>Name </span><strong> {{ item.name }}</strong>
              </div>
              <div>
                <span>Email </span> <a href="mailto:"> {{ item.email }}</a>
              </div>
            </template>
            <template v-slot:item.attatched_file_path="{ item }">
              <div v-if="item.attatched_file && item.attatched_file.length && item.attatched_file_path && item.attatched_file_path.length">
                <div v-for="(file, idx) in item.attatched_file" :key="idx">
                  <a :href="item.attatched_file_path[idx]" target="_blank" rel="noopener noreferrer">
                    {{ file }}
                  </a>
                </div>
              </div>
              <div v-else>
                N/A
              </div>
            </template>
          </v-data-table>
          <div class="text-center pt-4 pb-4">
            <Pagination
              :isloading="isLoading"
              :startRecord="startRecord"
              :currentPage="currentPage"
              :lastPage="lastPage"
              :lastRecord="lastRecord"
              :totRecords="totRecords"
              :totPage="totPage"
              :perpage="perpage"
              :isCurrentPageClass="isCurrentPageClass"
              :getLastPageClass="getLastPageClass"
              :getPages="getPages"
              @handlePerPage="handlePerPage"
              @paginate="paginate"
              @last="last"
              @getDataByPage="getDataByPage"
              :showPerPage="showPerPage"
            />
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Index from "./Index.vue";
import Buttons from "./component/Buttons.vue";
import Pagination from "./component/Pagination.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: { Index, Buttons, Loading, Pagination },
  name: "PanelistReport",
  data: () => ({
    toggleUpdateModal: false,
    options: {},
    sort: "",
    affinity_data: [],
    totalAffinity: 0,
    importFile: null,
    editReportMode: false,
    fromDateMenu: false,
    fromDateVal: null,
    isLoading: false,
    fullPage: true,
    allSelected: false,
    perpage: 10,
    retrieval_data: [],
    selectedRetrievalRecords: [],
    totRecords: "",
    totPage: "",
    currentPage: 1,
    lastPage: "",
    showPerPage: true,
    selectedAlerts: [],
    options: {},
    page: 1,
    alert_data: [],
    pageCount: 0,
    totalReports: 0,
    alertTitle: "",
    alertDesc: "",
    headers: [
      {
        text: "",
        value: "selectCheckbox",
        width: "50px",
        sortable: false,
        class: "v-data-table-header",
      },
      {
        text: "ID",
        value: "retrieval_id",
        width: "100px",
        sortable: false,
        class: "v-data-table-header",
      },
      {
        text: "Detail",
        width: "300px",
        value: "detail",
        sortable: false,
        class: "v-data-table-header",
      },
      {
        text: "Company",
        value: "company",
        sortable: false,
        class: "v-data-table-header",
      },
      {
        text: "Attached File",
        value: "attatched_file_path",
        sortable: false,
        class: "v-data-table-header",
      },
      {
        text: "Area Of Focus",
        value: "area_of_focus",
        sortable: false,
        class: "v-data-table-header",
      },
      {
        text: "Message",
        value: "message",
        align: "center",
        sortable: false,
        class: "v-data-table-header",
      },
      {
        text: "Need Fulfilled",
        value: "need_fulfill",
        sortable: false,
        class: "v-data-table-header",
      },
      {
        text: "Send Date",
        value: "inserted_date",
        sortable: false,
        class: "v-data-table-header",
      },
    ],
  }),
  async mounted() {
    this.getRetrievalMail();
  },
  computed: {
    //pagination computed methods
    startRecord: function () {
      return parseInt(this.lastRecord) - parseInt(this.perpage) + parseInt(1);
    },
    lastRecord: function () {
      return this.perpage * this.currentPage;
    },
    isCurrentPageClass: function () {
      return this.currentPage === 1 ? "" : "notactivespan";
    },
    getLastPageClass: function () {
      return parseInt(this.lastPage) === parseInt(this.currentPage)
        ? ""
        : "notactivespan";
    },

    getPages: function () {
      return this.$utils.getPages(
        this.lastPage,
        this.currentPage,
        this.totPage
      );
    },

    // lastPage: function () {
    //   console.log(this.totRecords,)
    //   console.log("last page >>>>",Math.ceil(this.totRecords/this.totPage)+1)
    //   return Math.ceil(this.totRecords/this.totPage)+1
    // },
  },
  methods: {
    addToSubmit(retrieval_id) {
      let view = this;
      view.retrieval_data.forEach(function (o, i) {
        console.log(
          "selected" + retrieval_id,
          view.selectedRetrievalRecords.includes(retrieval_id)
        );
        if (o.retrieval_id == retrieval_id) {
          if (view.selectedRetrievalRecords.includes(retrieval_id)) {
          } else {
          }
        }
      });
    },
    deleteRetrievalRecord() {
      let view = this;
      console.log(view.selectedRetrievalRecords);
      if (view.selectedRetrievalRecords.length > 0) {
        view.$swal
          .fire({
            title: "Are you sure ?",
            text: "This will remove Retrieval Service item",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, remove it !",
            cancelButtonText: "No, cancel !",
            closeOnConfirm: false,
            closeOnCancel: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              let client_basic_url =
                view.$url("RETRIVAL_SERVICES_MAIL_DELETE") +
                "?ids=" +
                view.selectedRetrievalRecords.join();
              view.isLoading = true;
              this.$fetch({
                requiresAuth: true,
                operation: "view",
                vueScope: view,
              })
                .delete(client_basic_url)
                .then((res) => {
                  const response = res;
                  if (!view.sectorAPILoading) view.isLoading = false;
                  this.$swal
                    .fire({
                      icon: response.status == "Failed" ? "error" : "success",
                      title:
                        response.status == "Failed"
                          ? "Record cannot be Deleted"
                          : "Record Deleted",
                      text: response.message,
                    })
                    .then((res) => {
                      if (res.isConfirmed) {
                        view.selectedRetrievalRecords = [];
                        view.isLoading = false;
                        view.trendTitle = "";
                        view.getRetrievalMail();
                      }
                    });
                })
                .catch((error) => {
                  view.isLoading = false;

                  view.$swal.fire({
                    position: "center",
                    icon: "error",
                    title: error,
                  });
                }); 
            } else {
              view.selected = [];
              view.isLoading = true;
            }
          });
      } else {
        view.$swal.fire({
          position: "center",
          icon: "error",
          title: "Please select atleast one record",
        });
      }
    },

    getRetrievalMail() {
      let view = this;
      let retrievalMail_url = view.$url("RETRIVAL_SERVICES_MAIL");
      const config = { page_number: view.currentPage, page_size: view.perpage };

      try {
        view.isLoading = true;
        this.$fetch({ requiresAuth: true, operation: "view", vueScope: view })
          .post(retrievalMail_url, config)
          .then((res) => {
            view.retrieval_data = res.data.data;
            view.page = res.current_page;
            view.perpage = res.data.page_size;
            view.totRecords = res.data.total_records;
            view.totPage = parseInt(res.data.total_pages);
            view.lastPage = Math.ceil(view.totRecords / view.perpage);
            view.isLoading = false;
          })
          .catch((error) => {
            view.isLoading = false;
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: error,
            });
          });
      } catch (e) {
        view.isLoading = false;
        console.log("error", e);
      }
    },

    selectAll: function () {
      let view = this;
      let retrievalDataLength = view.retrieval_data;
      if (this.allSelected == true) {
        if (Array.isArray(retrievalDataLength) && retrievalDataLength.length) {
          this.selectedRetrievalRecords = [];
          let i;
          for (i = 0; i < retrievalDataLength.length; i++) {
            this.selectedRetrievalRecords.push(
              retrievalDataLength[i].retrieval_id
            );
          }
        }
      } else if (this.allSelected == false) {
        this.selectedRetrievalRecords = [];
      }
    },

    getDataByPage(page) {
      let view = this;
      console.log("Data", page);
      this.currentPage = page;
      view.getRetrievalMail();
    },
    handlePerPage(p) {
      console.log("perpage", p);
      let view = this;
      this.perpage = p;
      this.currentPage = 1;
      this.getRetrievalMail();
    },
    paginate(n) {
      console.log(n);
      let view = this;
      if (
        parseInt(n) === parseInt(0) &&
        parseInt(this.currentPage) === parseInt(1)
      ) {
        return;
      }
      if (parseInt(n) === parseInt(-1)) {
        if (parseInt(this.currentPage) <= parseInt(1)) {
          return;
        }
      }
      if (parseInt(n) === parseInt(1)) {
        if (parseInt(this.currentPage) >= parseInt(this.lastPage)) {
          return;
        }
      }
      let myPromise = new Promise(function (resolve, reject) {
        resolve(
          (view.currentPage =
            n === 0 ? 1 : parseInt(view.currentPage) + parseInt(n))
        );
        reject("Error: on set page");
      });
      myPromise
        .then(function () {
          view.getRetrievalMail();
        })
        .catch(function (e) {
          console.log(e);
        });
    },
    last() {
      let view = this;
      console.log("last", view.lastPage);
      if (parseInt(view.lastPage) === parseInt(view.currentPage)) {
        return;
      }
      this.currentPage = this.lastPage;
      this.getRetrievalMail();
    },
  },
};
</script>
